export default [
  {
    path: '/news',
    name: 'news',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Новини',
      breadcrumb: 'Новини',
    },
    component: () => import('../pages/news-page'),
  },
  {
    path: '/news/:slug',
    name: 'newShow',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true, title: 'Новини'
    },
    component: () => import('../pages/news-page/show.vue'),
  },
]
